"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*

The actual code for the my page component is found in rubics-service

*/
var Form = {
    name: "global:form",
    label: "Skjema",
    description: "Med Skjema-komponenten kan du samle inn informasjon fra dine besøkende.",
    reactComponent: function () { return null; },
    icon: "form",
    usableInSection: true,
    usableInRichContent: true,
    props: [
        {
            name: "form",
            label: "Skjema",
            type: "form",
            required: true,
        },
    ],
};
exports.default = Form;
//# sourceMappingURL=index.js.map